import { ApiClient } from '../../api-client/api-client';

export const getJobStatusByUniqueIdentifier = (uniqueIdentifier: string) => {
  return ApiClient.getJobStatusByUniqueIdentifier({ uniqueIdentifier }).then((res) => res.data);
};
